import client from '../client';

export const moduleApi = {
  getAvailableModules: async () => {
    const response = await client.get('/schools/list-modules');
    return response.data;
  },

  getAssignedModules: async (schoolId) => {
    const response = await client.get(`/schools/${schoolId}/modules`);
    return response.data;
  },

  assignModules: async (schoolId, moduleIds) => {
    const response = await client.put(`/schools/${schoolId}/modules`, {
      module_ids: moduleIds,
    });
    return response.data;
  },
};
